export const SECTION_PREFIX = '<section:>';
export const GROUP_PREFIX = '<group:>';
